import ShipLine from './ShipLine'

export default ShipLine
